import maskInput from "./maskInput";
import masks from "../constants/masks";

export default function maskDateInput(input: string): string {
    // TODO: Leap Year
    const maskedValue = maskInput(masks.dateOfBirth.pattern, input);

    let result = "";
    const dateParts = maskedValue.split("/");
    const month = dateParts[0];
    const day = dateParts[1];
    const year = dateParts[2];

    // Month Validation
    if (month) {
        if (month.length > 1) {
            const monthInt = parseInt(month, 10);

            if (monthInt >= 1 && monthInt <= 12) {
                result += month;
            } else {
                return maskInput(masks.dateOfBirth.pattern, result + month[0]);
            }
        } else {
            const monthInt = parseInt(month, 10);

            if (monthInt >= 0 && monthInt <= 1) {
                return maskInput(masks.dateOfBirth.pattern, (result += monthInt));
            } else {
                return maskInput(masks.dateOfBirth.pattern, result);
            }
        }
    }

    // Day validation
    if (day) {
        result += "/";
        if (day.length > 1) {
            const dayInt = parseInt(day, 10);

            if (dayInt >= 1 && dayInt <= 31) {
                result += day;
            } else {
                return maskInput(masks.dateOfBirth.pattern, result + day[0]);
            }
        } else {
            const dayInt = parseInt(day, 10);

            if (dayInt >= 0 && dayInt <= 3) {
                return maskInput(masks.dateOfBirth.pattern, (result += dayInt));
            } else {
                return maskInput(masks.dateOfBirth.pattern, result);
            }
        }
    }

    // Year Validation
    if (year) {
        result += "/";
        const yearInt1 = parseInt(year[0]);

        if (yearInt1 >= 1 && yearInt1 <= 2) {
            result += yearInt1;
        } else {
            return maskInput(masks.dateOfBirth.pattern, result);
        }

        if (year.length >= 2) {
            const yearInt2 = parseInt(year[1]);

            if ((yearInt1 === 1 && yearInt2 === 9) || (yearInt1 === 2 && yearInt2 === 0)) {
                result += yearInt2;
            } else {
                return maskInput(masks.dateOfBirth.pattern, result);
            }
        }
        if (year.length >= 3) {
            result += year[2];
        }
        if (year.length >= 4) {
            result += year[3];
        }
    }

    return maskedValue; // Input valid as is so return.
}
